export default {
  on: {
    VALIDATE: 'validate'
  },
  initial: 'idle',
  states: {
    idle: {},
    validate: {
      invoke: {
        src: 'validating',
        onDone: {
          target: 'valid',
          actions: ['addToList']
        },
        onError: 'invalid',
      }
    },
    valid: {},
    invalid: {}
  }
}